import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../redux/store';
import { API_BASE_URL } from '../helpers/common';

export interface IUserCompany {
  id: number;
  name: string;
  companyType: string;
  imageUrl?: string;
  isCurrentCompany: boolean;
}

export const companiesApi = createApi({
  reducerPath: 'companiesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      token && headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['UserCompanies'],
  endpoints: (builder) => ({
    getUserCompanies: builder.query<IUserCompany[], void>({
      query: () => '/companies/user-companies',
      transformResponse: (response: { data: IUserCompany[] }) => response.data,
      providesTags: ['UserCompanies'],
    }),
  }),
});

export const { 
  useGetUserCompaniesQuery,
} = companiesApi;
